import React, { useState, useEffect } from 'react';
import {
    Button,
    Dialog,
    Box,
    Grid,
    makeStyles,
    DialogTitle,
    DialogContent,
    FormControl,
    Select,
    InputLabel,
    TextField,
    CircularProgress,
    MenuItem,
    OutlinedInput,
} from '@material-ui/core';

import Autocomplete from '@material-ui/lab/Autocomplete';
import { CustomToast } from '@jumbo/components/custom/Toast';

// NO TOCAR ESTOS IMPORTS 👇
import { formatRut, LABEL_INPUT_FONT_SIZE, validateRut } from 'routes/Pages/FichasTecnicas/ConstsAndUtils/utils';
import { EXCLUDE_FROM_ODONTOLOGIA, PRIVADOS, TEXT_COLOR_FT } from 'config/config';
import GridContainer from '@jumbo/components/GridContainer';
import { Save } from '@material-ui/icons';

const addStyle = makeStyles(theme => ({
    dialogRoot: {
        position: 'relative',
    },
    dialogTitleRoot: {
        '& .MuiTypography-h6': {
            fontSize: 16,
            color: theme.palette.common.dark,
        },
    },
}));

/**
 * props:
 * - openDialog: bool
 * - close: fn
 * - dataCrear: datos iniciales (para ver/editar) o {} para crear
 * - postData: fn(payload)
 * - isView: bool (true = solo ver)
 * - optionsEquipamiento: [{ id, codigo, descripcion }, ...]
 */
const ModalCargarEquipamiento = props => {
    const {
        openDialog = false,
        close,
        dataCrear,
        postData,
        isView = false,
        optionsEquipamiento = [],
        autoridades = []
    } = props;

    const [loading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const classes = addStyle();

    useEffect(() => {
        if (dataCrear) {
            setFormData({ ...dataCrear });
        } else {
            setFormData({});
        }
        setIsLoading(false);
    }, [dataCrear, openDialog]);

    const onCloseDialog = (event, reason) => {
        if (reason !== 'backdropClick') {
            clearData();
            close();
        }
    };

    const clearData = () => {
        setIsLoading(false);
    };

    const handleChange = (field) => (event) => {
        const value = event.target.value;

        if (field === 'n_autorizacion_sanitaria') {
            if (!/^\d*$/.test(value)) return;
            const numericValue = value.replace(/^0+/, '');

            if (numericValue.length <= 9) {
                setFormData(prev => ({
                    ...prev,
                    [field]: numericValue,
                }));
            }
        }else if (field === 'garantia_vigente') {

            setFormData(prev => ({
                ...prev,
                [field]: value,
                'fecha_expiracion_garantia': ''
            }));


        } else {
            setFormData(prev => ({
                ...prev,
                [field]: value,
            }));
        }

    };

    const validateForm = () => {
        if (!formData.codigo) {
            return true
        }
        return false;
    };

    const selectedCodigoOption =
        optionsEquipamiento.find(opt => opt.codigo === formData.codigo) || null;

    const titulo = isView
        ? (formData?.equipamiento ? `Ver ${formData.equipamiento}` : 'Ver equipamiento')
        : formData?.id
            ? (formData?.equipamiento ? `Editar ${formData.equipamiento}` : 'Editar registro')
            : 'Nuevo equipamiento';

    const handleSubmit = () => {
        // setIsLoading(true);

        // Separamos código / equipamiento usando la opción seleccionada
        const selected =
            optionsEquipamiento.find(opt => opt.codigo === formData.codigo) || null;

        //const nombre_autoridad = autoridades.find(e => e.value === parseInt(formData.autoridad_que_otorga))

        const payload = {
            ...formData,
            codigo: selected ? selected.codigo : formData.codigo || null,
            equipamiento: selected ? selected.descripcion : formData.equipamiento || null,
            id_equipamiento_medico: selected
                ? selected.id
                : formData.id_equipamiento_medico || null,
            nro_serie:selected ? formData.n_serie : null,
            id_tipo_servicio: selected ? formData.propiedad : null,
            nro_resolucion : selected ? formData.n_autorizacion_sanitaria : null,
            fecha_exp_garantia: formData.fecha_expiracion_garantia ? formData.fecha_expiracion_garantia : null,
            nom_autoridad:formData.autoridad_que_otorga
           // nom_autoridad:nombre_autoridad.label,
        };

        postData(payload);
        clearData()
        close()
    };

    return (
        <Dialog open={openDialog} onClose={onCloseDialog}>
            <CustomToast />
            <DialogTitle className={classes.dialogTitleRoot}>
                <Grid container justifyContent='space-between' style={{ color: TEXT_COLOR_FT }}>
                    <Grid item>{titulo}</Grid>
                </Grid>
            </DialogTitle>
            <DialogContent dividers>
                <Box
                    display="flex"
                    flexDirection={{ xs: 'column', md: 'row' }}
                    alignItems="center"
                    mb={{ xs: 6, md: 5 }}
                >
                    <GridContainer>
                        {/* Código con Autocomplete (único campo “identificador” visible) */}
                        <Grid item xs={12} md={12}>
                            <Autocomplete
                                disabled={isView}
                                options={optionsEquipamiento}
                                value={selectedCodigoOption}
                                getOptionLabel={option =>
                                    option ? `${option.codigo} - ${option.descripcion}` : ''
                                }
                                onChange={(event, newValue) => {
                                    if (isView) return;
                                    setFormData(prev => ({
                                        ...prev,
                                        codigo: newValue ? newValue.codigo : '',
                                        // guardamos descripción internamente, aunque ya no haya campo visible
                                        equipamiento: newValue ? newValue.descripcion : '',
                                        id_equipamiento_medico: newValue
                                            ? newValue.id
                                            : prev.id_equipamiento_medico,
                                    }));
                                }}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        margin="dense"
                                        variant="outlined"
                                        label="Código"
                                        InputLabelProps={{
                                            shrink: true,
                                            style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        {/* Marca */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                label="Marca"
                                value={formData.marca || ''}
                                onChange={handleChange('marca')}
                                disabled={isView}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                            />
                        </Grid>

                        {/* Modelo */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                label="Modelo"
                                value={formData.modelo || ''}
                                onChange={handleChange('modelo')}
                                disabled={isView}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                            />
                        </Grid>

                        {/* Nº Serie */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                label="Nº Serie"
                                value={formData.n_serie || ''}
                                onChange={handleChange('n_serie')}
                                disabled={isView}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                            />
                        </Grid>

                        {/* Garantía vigente */}
                        <Grid item xs={12} md={6}>
                            <FormControl
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                disabled={isView}
                            >
                                <InputLabel
                                    shrink
                                    style={{ fontSize: LABEL_INPUT_FONT_SIZE }}
                                    id="garantia-label"
                                >
                                    Garantía vigente
                                </InputLabel>
                                <Select
                                    labelId="garantia-label"
                                    value={formData.garantia_vigente || ''}
                                    onChange={handleChange('garantia_vigente')}
                                    input={
                                        <OutlinedInput
                                            notched
                                            label="Garantía vigente"
                                        />
                                    }
                                >
                                    <MenuItem value="">
                                        <em>Seleccione</em>
                                    </MenuItem>
                                    <MenuItem value="SI">Sí</MenuItem>
                                    <MenuItem value="NO">No</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Fecha expiración garantía */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                disabled={formData.garantia_vigente === 'SI' ? false : true}
                                fullWidth
                                type='date'
                                margin="dense"
                                variant="outlined"
                                label="Fecha expiración garantía"
                                placeholder="dd/mm/aaaa"
                                value={formData.fecha_expiracion_garantia || ''}
                                onChange={handleChange('fecha_expiracion_garantia')}
                                
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                                inputProps={{
                                    maxLength: 10,
                                }}
                            />
                        </Grid>

                        {/* Periodicidad mantención */}
                        <Grid item xs={12} md={6}>
                            <FormControl
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                disabled={isView}
                            >
                                <InputLabel
                                    shrink
                                    style={{ fontSize: LABEL_INPUT_FONT_SIZE }}
                                    id="periodicidad-label"
                                >
                                    Periodicidad mantención
                                </InputLabel>
                                <Select
                                    labelId="periodicidad-label"
                                    value={formData.periodicidad_mantencion || ''}
                                    onChange={handleChange('periodicidad_mantencion')}
                                    input={
                                        <OutlinedInput
                                            notched
                                            label="Periodicidad mantención"
                                        />
                                    }
                                >
                                    <MenuItem value="">
                                        <em>Seleccione</em>
                                    </MenuItem>
                                    <MenuItem value="Mensual">Mensual</MenuItem>
                                    <MenuItem value="Bimensual">Bimensual</MenuItem>
                                    <MenuItem value="Trimestral">Trimestral</MenuItem>
                                    <MenuItem value="Semestral">Semestral</MenuItem>
                                    <MenuItem value="Anual">Anual</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Propio / Comodato */}
                        <Grid item xs={12} md={6}>
                            <FormControl
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                disabled={isView}
                            >
                                <InputLabel
                                    shrink
                                    style={{ fontSize: LABEL_INPUT_FONT_SIZE }}
                                    id="propiedad-label"
                                >
                                    Propio / Comodato
                                </InputLabel>
                                <Select
                                    labelId="propiedad-label"
                                    value={formData.propiedad || ''}
                                    onChange={handleChange('propiedad')}
                                    input={
                                        <OutlinedInput
                                            notched
                                            label="Propio / Comodato"
                                        />
                                    }
                                >
                                    <MenuItem value="">
                                        <em>Seleccione</em>
                                    </MenuItem>
                                    <MenuItem value="PROPIO">Propio</MenuItem>
                                    <MenuItem value="COMODATO">Comodato</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Nº Autorización sanitaria */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                label="Nº Autorización sanitaria"
                                value={formData.n_autorizacion_sanitaria || ''}
                                onChange={handleChange('n_autorizacion_sanitaria')}
                                disabled={isView}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                            />
                        </Grid>

                        {/* Fecha Resolución */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                type='date'
                                margin="dense"
                                variant="outlined"
                                label="Fecha Resolución"
                                placeholder="dd/mm/aaaa"
                                value={formData.fecha_resolucion || ''}
                                onChange={handleChange('fecha_resolucion')}
                                disabled={isView}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                                inputProps={{
                                    maxLength: 10,
                                }}
                            />
                        </Grid>

                        {/* Autoridad que otorga */}
                        <Grid item xs={6}>

                            <FormControl size='small' fullWidth>
                                <InputLabel
                                    inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                    htmlFor="grouped-native-select"
                                    style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                                    Autoridad que otorga
                                </InputLabel>
                                <Select
                                    inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                    native
                                    label='Autoridad que otorga'
                                    id="grouped-native-select"
                                    fullWidth
                                    variant='outlined'
                                    value={formData.autoridad_que_otorga || ''}
                                    onChange={(e) => {
                                        const val = e.target.value
                                        setFormData(prev => ({
                                            ...prev,
                                            autoridad_que_otorga: val,
                                        }));
                                     
                                    }}

                                >
                                    {
                                        autoridades.map((option, index) => {
                                            return <option key={index + 1} value={option.value}>
                                                {option.label}
                                            </option>
                                        })
                                    }
                                </Select>
                            </FormControl>

                        </Grid>
                        {/*                         <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                label="Autoridad que otorga"
                                value={formData.autoridad_que_otorga || ''}
                                onChange={handleChange('autoridad_que_otorga')}
                                disabled={isView}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                            />
                        </Grid> */}
                    </GridContainer>
                </Box>

                <Box display="flex" justifyContent="flex-end" mb={4}>
                    <Button onClick={onCloseDialog} disabled={loading} variant='outlined'>
                        Cerrar
                    </Button>

                    {!isView && (
                        <Box ml={2}>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={handleSubmit}
                                disabled={validateForm() || loading}
                            >
                                <Save style={{ marginRight: 10 }} />
                                {loading ? (
                                    <CircularProgress
                                        color="inherit"
                                        style={{ height: '22px', width: '22px' }}
                                    />
                                ) : (
                                    formData?.id ? 'Actualizar' : 'Guardar'
                                )}
                            </Button>
                        </Box>
                    )}
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default ModalCargarEquipamiento;
